/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from "axios";

import { Expose, Transform, Type, plainToClass } from "class-transformer";

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(
    configs: IRequestConfig,
    resolve: (p: any) => void,
    reject: (p: any) => void
): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error("please inject yourself instance like axios  ");
    }
}

export function getConfigs(
    method: string,
    contentType: string,
    url: string,
    options: any
): IRequestConfig {
    const configs: IRequestConfig = { ...options, method, url };
    configs.headers = {
        ...options.headers,
        "Content-Type": contentType,
    };
    return configs;
}

export const basePath = "";

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class CaseSubTypeService {
    /**
     *
     */
    static caseType(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseSubType/caseType/{caseTypeID}";
            url = url.replace("{caseTypeID}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static caseSubType(
        params: {
            /**  */
            caseSubTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseSubType/{caseSubTypeId}";
            url = url.replace("{caseSubTypeId}", params["caseSubTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static code(
        params: {
            /**  */
            divisionId: string;
            /**  */
            code: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseSubType/code/{divisionId}/{code}";
            url = url.replace("{divisionId}", params["divisionId"] + "");
            url = url.replace("{code}", params["code"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static text(
        params: {
            /**  */
            divisionId: string;
            /**  */
            name?: string;
            /**  */
            caseTypeName?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseSubType/text/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                name: params["name"],
                caseTypeName: params["caseTypeName"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            divisionId: string;
            /**  */
            eportalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/CaseSubType/ePortalID/{divisionId}/{eportalId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");
            url = url.replace("{eportalId}", params["eportalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static division(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseSubType/division/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            casetypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseSubType/update/{casetypeId}";
            url = url.replace("{casetypeId}", params["casetypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
}

export class CaseTypeService {
    /**
     *
     */
    static caseType(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseType/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static division(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseType/division/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static portal(
        params: {
            /**  */
            countyId: string;
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseTypeListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseType/portal/{countyId}/{divisionId}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CaseTypeListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static sync(
        params: {
            /**  */
            countyId: string;
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseTypeStagingListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseType/sync/{countyId}/{divisionId}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CaseTypeStagingListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static division1(
        params: {
            /**  */
            divisionId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/CaseType/division/{divisionID}/{ePortalID}";
            url = url.replace("{divisionID}", params["divisionId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseType/update/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static byname(
        params: {
            /**  */
            divisionId: string;
            /**  */
            name?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseType/division/{divisionId}/byname";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { name: params["name"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
}

export class CodesService {
    /**
     *
     */
    static crossreference(
        options: IRequestOptions = {}
    ): Promise<CrossReferenceCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/crossreference";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CrossReferenceCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static crossreference1(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CrossReferenceCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/crossreference/{CaseTypeID}";
            url = url.replace("{CaseTypeID}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CrossReferenceCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static damage(options: IRequestOptions = {}): Promise<DamageCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/damage";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DamageCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static damage1(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DamageCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/damage/{DivisionID}";
            url = url.replace("{DivisionID}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DamageCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static division(
        params: {
            /**  */
            divisionId: string;
            /**  */
            eportalid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DamageCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Codes/damage/division/{divisionId}/{eportalid}";
            url = url.replace("{divisionId}", params["divisionId"] + "");
            url = url.replace("{eportalid}", params["eportalid"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DamageCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filer(options: IRequestOptions = {}): Promise<FilerCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filer";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(FilerCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filer1(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilerCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filer/{CountyID}";
            url = url.replace("{CountyID}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(FilerCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filing(options: IRequestOptions = {}): Promise<FilingCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filing";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filing1(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            newCase?: boolean;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filing/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { newCase: params["newCase"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filing/county/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            countyId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Codes/filing/county/{countyID}/ePortalID/{ePortalID}";
            url = url.replace("{countyID}", params["countyId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static id(
        params: {
            /**  */
            filingCodeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filing/id/{filingCodeId}";
            url = url.replace("{filingCodeId}", params["filingCodeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingcomponent(
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filingcomponent";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county1(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/filingcomponent/County/{CountyID}";
            url = url.replace("{CountyID}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingCode(
        params: {
            /**  */
            filingCodeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Codes/filingcomponent/FilingCode/{FilingCodeID}";
            url = url.replace("{FilingCodeID}", params["filingCodeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static id1(
        params: {
            /**  */
            filingComponentId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Codes/filingcomponent/id/{filingComponentId}";
            url = url.replace(
                "{filingComponentId}",
                params["filingComponentId"] + ""
            );

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static optionalservice(
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/optionalservice";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingCode1(
        params: {
            /**  */
            countyId: string;
            /**  */
            filingCodeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Codes/optionalservice/County/{CountyID}/FilingCode/{FilingCodeID}";
            url = url.replace("{CountyID}", params["countyId"] + "");
            url = url.replace("{FilingCodeID}", params["filingCodeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county2(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/optionalservice/County/{CountyID}";
            url = url.replace("{CountyID}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId1(
        params: {
            /**  */
            filingCodeId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Codes/optionsalservice/FilingCode/{FilingCodeID}/ePortalID/{ePortalID}";
            url = url.replace("{FilingCodeID}", params["filingCodeId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static remedy(options: IRequestOptions = {}): Promise<RemedyCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/remedy";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(RemedyCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static remedy1(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<RemedyCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Codes/remedy/{divisionID}";
            url = url.replace("{divisionID}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(RemedyCode, response)),
                reject
            );
        });
    }
}

export class CountyService {
    /**
     *
     */
    static county(options: IRequestOptions = {}): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/County";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static state(
        params: {
            /**  */
            state: string;
            /**  */
            all?: boolean;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/County/state/{state}";
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { all: params["all"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static stateid(
        params: {
            /**  */
            stateId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/County/stateid/{stateId}";
            url = url.replace("{stateId}", params["stateId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county1(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/County/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static portalid(
        params: {
            /**  */
            stateId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/County/portalid/{stateId}/{ePortalId}";
            url = url.replace("{stateId}", params["stateId"] + "");
            url = url.replace("{ePortalId}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            portalIdentifier: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/County/update/{portalIdentifier}";
            url = url.replace(
                "{portalIdentifier}",
                params["portalIdentifier"] + ""
            );

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
}

export class CourtTypeService {
    /**
     *
     */
    static courtType(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CourtType/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(CourtType, response)),
                reject
            );
        });
    }
}

export class CoversheetService {
    /**
     *
     */
    static courttypes(
        params: {
            /**  */
            state: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetCourtType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/courttypes/{state}";
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CoversheetCourtType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static caseTypes(
        params: {
            /**  */
            courtTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetCaseType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/caseTypes/{courtTypeId}";
            url = url.replace("{courtTypeId}", params["courtTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CoversheetCaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static caseSubTypes(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetCaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/caseSubTypes/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CoversheetCaseSubType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static list(
        params: {
            /**  */
            courtTypeId: string;
            /**  */
            caseTypeId: string;
            /**  */
            caseSubTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseTypeCoverSheetDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Coversheet/list/{courtTypeId}/{caseTypeId}/{caseSubTypeId}";
            url = url.replace("{courtTypeId}", params["courtTypeId"] + "");
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");
            url = url.replace("{caseSubTypeId}", params["caseSubTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CaseTypeCoverSheetDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static mapped(
        params: {
            /** requestBody */
            body?: MappedCoversheetRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseTypeCoverSheetDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/mapped";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CaseTypeCoverSheetDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static caseType(
        params: {
            /**  */
            id?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetCaseTypeDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/caseType";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { id: params["id"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CoversheetCaseTypeDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static caseType1(
        params: {
            /** requestBody */
            body?: CoversheetCaseType;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetCaseTypeDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/caseType";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CoversheetCaseTypeDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static caseType2(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: CoversheetCaseType;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetCaseTypeDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/caseType/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CoversheetCaseTypeDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static caseType3(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetCaseTypeDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/caseType/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CoversheetCaseTypeDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class DataTagService {
    /**
     *
     */
    static dataTag(options: IRequestOptions = {}): Promise<DataTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTag";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static active(options: IRequestOptions = {}): Promise<DataTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTag/active";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static dataTag1(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTag/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static insert(
        params: {
            /** requestBody */
            body?: DataTag;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTag/insert";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static delete(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTag/delete/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static dataTag2(options: IRequestOptions = {}): Promise<DataTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DataTag";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static active1(options: IRequestOptions = {}): Promise<DataTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DataTag/active";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static dataTag3(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DataTag/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static insert1(
        params: {
            /** requestBody */
            body?: DataTag;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DataTag/insert";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static delete1(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DataTag/delete/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DataTag, response)),
                reject
            );
        });
    }
}

export class DataTagMapService {
    /**
     *
     */
    static mappings(
        params: {
            /** requestBody */
            body?: any | null[];
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTagMap[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTagMap/mappings";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DataTagMap, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static mappings1(
        params: {
            /**  */
            mergefield: string;
            /**  */
            mergefields: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTagMap> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTagMap/mappings/{mergefields}";
            url = url.replace("{mergefield}", params["mergefield"] + "");
            url = url.replace("{mergefields}", params["mergefields"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DataTagMap, response)),
                reject
            );
        });
    }
}

export class DivisionService {
    /**
     *
     */
    static county(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/county/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static division(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static judicialofficers(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JudicialOfficerListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/{divisionId}/judicialofficers";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            JudicialOfficerListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static division1(
        params: {
            /**  */
            countyId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/{countyId}/{ePortalId}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{ePortalId}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static byname(
        params: {
            /**  */
            countyId: string;
            /**  */
            name?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/{countyId}/byname";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { name: params["name"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static divisionbyaddress(
        params: {
            /** requestBody */
            body?: DivisionLocationRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/divisionbyaddress";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static divisionbylatlon(
        params: {
            /** requestBody */
            body?: DivisionLocationRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/divisionbylatlon";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Division/update/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
}

export class DocumentTagService {
    /**
     *
     */
    static documentTag(options: IRequestOptions = {}): Promise<DocumentTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DocumentTag";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static active(options: IRequestOptions = {}): Promise<DocumentTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DocumentTag/active";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static documentTag1(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DocumentTag/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static insert(
        params: {
            /** requestBody */
            body?: DocumentTag;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DocumentTag/insert";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static delete(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DocumentTag/delete/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static documentTag2(options: IRequestOptions = {}): Promise<DocumentTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DocumentTag";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static active1(options: IRequestOptions = {}): Promise<DocumentTag[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DocumentTag/active";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static documentTag3(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DocumentTag/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static insert1(
        params: {
            /** requestBody */
            body?: DocumentTag;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DocumentTag/insert";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static delete1(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentTag> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DocumentTag/delete/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DocumentTag, response)),
                reject
            );
        });
    }
}

export class DocumentTypeService {
    /**
     *
     */
    static id(
        params: {
            /**  */
            docTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DocumentType/id/{docTypeID}";
            url = url.replace("{docTypeID}", params["docTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorneyType(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            attorneyType: AttorneyTypeKeys;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/DocumentType/caseType/{caseTypeId}/attorneyType/{attorneyType}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");
            url = url.replace("{attorneyType}", params["attorneyType"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/DocumentType/county/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county1(
        params: {
            /**  */
            countyId: string;
            /**  */
            caseTypeId: string;
            /**  */
            attorneyType: AttorneyTypeKeys;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/DocumentType/county/{countyId}/{caseTypeId}/{attorneyType}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");
            url = url.replace("{attorneyType}", params["attorneyType"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/DocumentType/caseType/{caseTypeID}/ePortalID/{ePortalID}";
            url = url.replace("{caseTypeID}", params["caseTypeId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingCode(
        params: {
            /**  */
            countyId: string;
            /**  */
            filingCode: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/DocumentType/county/{countyID}/filingCode/{filingCode}";
            url = url.replace("{countyID}", params["countyId"] + "");
            url = url.replace("{filingCode}", params["filingCode"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
}

export class FeeService {
    /**
     *
     */
    static fee(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IFee[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Fee/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(IFee, response)),
                reject
            );
        });
    }
}

export class FilingHelpNoteService {
    /**
     *
     */
    static filingHelpNote(
        params: {
            /** requestBody */
            body?: FilingHelpNoteRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GroupedNotesDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/FilingHelpNote";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(GroupedNotesDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class JudicialOfficerService {
    /**
     *
     */
    static judicialofficer(
        params: {
            /**  */
            countyId: string;
            /**  */
            name?: string;
            /**  */
            division?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JudicialOfficerDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/JudicialOfficer/judicialofficer/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                name: params["name"],
                division: params["division"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JudicialOfficerDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static judicialofficer1(
        params: {
            /** requestBody */
            body?: JudicialOfficer;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JudicialOfficerDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JudicialOfficer/judicialofficer";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JudicialOfficerDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class JusticeOfPeaceLocatorService {
    /**
     *
     */
    static justiceOfPeaceLocator(
        params: {
            /**  */
            address?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JPLocationDataDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JusticeOfPeaceLocator";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { address: params["address"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JPLocationDataDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static file(
        params: {
            /**  */
            headers?: boolean;
            /**  */
            file: any;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JusticeOfPeaceLocator/file";

            const configs: IRequestConfig = getConfigs(
                "post",
                "multipart/form-data",
                url,
                options
            );
            configs.params = { headers: params["headers"] };
            let data = null;
            data = new FormData();
            if (params["file"]) {
                if (
                    Object.prototype.toString.call(params["file"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["file"]) {
                        data.append("file", item as any);
                    }
                } else {
                    data.append("file", params["file"] as any);
                }
            }

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}

export class PartyTypeService {
    /**
     *
     */
    static partyType(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IPartyType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/PartyType/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IPartyType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static byname(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            name?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyTypeCode> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/PartyType/caseType/{caseTypeId}/byname";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { name: params["name"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyTypeCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyTypeCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/PartyType/caseType/{caseTypeId}/ePortalID/{ePortalID}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyTypeCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId1(
        params: {
            /**  */
            countyId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyTypeCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/PartyType/county/{countyID}/ePortalID/{ePortalID}";
            url = url.replace("{countyID}", params["countyId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyTypeCode, response)),
                reject
            );
        });
    }
}

export class StateService {
    /**
     *
     */
    static state(options: IRequestOptions = {}): Promise<State[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/State";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(State, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static state1(
        params: {
            /**  */
            name: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<State> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/State/{name}";
            url = url.replace("{name}", params["name"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(State, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static state2(
        params: {
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<State> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/State/{ePortalID}";
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(State, response)),
                reject
            );
        });
    }
}

export class TylerCaseSubTypeService {
    /**
     *
     */
    static caseType(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCaseSubType/caseType/{caseTypeID}";
            url = url.replace("{caseTypeID}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static tylerCaseSubType(
        params: {
            /**  */
            caseSubTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCaseSubType/{caseSubTypeId}";
            url = url.replace("{caseSubTypeId}", params["caseSubTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static code(
        params: {
            /**  */
            divisionId: string;
            /**  */
            code: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCaseSubType/code/{divisionId}/{code}";
            url = url.replace("{divisionId}", params["divisionId"] + "");
            url = url.replace("{code}", params["code"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static text(
        params: {
            /**  */
            divisionId: string;
            /**  */
            name?: string;
            /**  */
            caseTypeName?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCaseSubType/text/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                name: params["name"],
                caseTypeName: params["caseTypeName"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            divisionId: string;
            /**  */
            eportalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCaseSubType/ePortalID/{divisionId}/{eportalId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");
            url = url.replace("{eportalId}", params["eportalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static division(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCaseSubType/division/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            casetypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSubType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCaseSubType/update/{casetypeId}";
            url = url.replace("{casetypeId}", params["casetypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseSubType, response)),
                reject
            );
        });
    }
}

export class TylerCaseTypeService {
    /**
     *
     */
    static tylerCaseType(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCaseType/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static division(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCaseType/division/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static staging(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseTypeStaging[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCaseType/division/{divisionId}/staging";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CaseTypeStaging, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static portal(
        params: {
            /**  */
            countyId: string;
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseTypeListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCaseType/portal/{countyId}/{divisionId}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CaseTypeListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static sync(
        params: {
            /**  */
            countyId: string;
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseTypeStagingListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCaseType/sync/{countyId}/{divisionId}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CaseTypeStagingListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static division1(
        params: {
            /**  */
            divisionId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCaseType/division/{divisionID}/{ePortalID}";
            url = url.replace("{divisionID}", params["divisionId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCaseType/update/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static byname(
        params: {
            /**  */
            divisionId: string;
            /**  */
            name?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCaseType/division/{divisionId}/byname";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { name: params["name"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(CaseType, response)),
                reject
            );
        });
    }
}

export class TylerCodesService {
    /**
     *
     */
    static crossreference(
        options: IRequestOptions = {}
    ): Promise<CrossReferenceCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/crossreference";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CrossReferenceCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static crossreference1(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CrossReferenceCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCodes/crossreference/{CaseTypeID}";
            url = url.replace("{CaseTypeID}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(CrossReferenceCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static damage(options: IRequestOptions = {}): Promise<DamageCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/damage";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DamageCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static damage1(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DamageCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/damage/{DivisionID}";
            url = url.replace("{DivisionID}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(DamageCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static division(
        params: {
            /**  */
            divisionId: string;
            /**  */
            eportalid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DamageCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/damage/division/{divisionId}/{eportalid}";
            url = url.replace("{divisionId}", params["divisionId"] + "");
            url = url.replace("{eportalid}", params["eportalid"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(DamageCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filer(options: IRequestOptions = {}): Promise<FilerCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/filer";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(FilerCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filer1(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilerCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/filer/{CountyID}";
            url = url.replace("{CountyID}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(FilerCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filing(options: IRequestOptions = {}): Promise<FilingCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/filing";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filing1(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            newCase?: boolean;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/filing/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { newCase: params["newCase"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCodes/filing/county/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            countyId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/filing/county/{countyID}/ePortalID/{ePortalID}";
            url = url.replace("{countyID}", params["countyId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static id(
        params: {
            /**  */
            filingCodeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCodes/filing/id/{filingCodeId}";
            url = url.replace("{filingCodeId}", params["filingCodeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(FilingCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingcomponent(
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/filingcomponent";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county1(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/filingcomponent/County/{CountyID}";
            url = url.replace("{CountyID}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingCode(
        params: {
            /**  */
            filingCodeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/filingcomponent/FilingCode/{FilingCodeID}";
            url = url.replace("{FilingCodeID}", params["filingCodeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static id1(
        params: {
            /**  */
            filingComponentId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilingComponentCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/filingcomponent/id/{filingComponentId}";
            url = url.replace(
                "{FilingComponentID}",
                params["filingComponentId"] + ""
            );

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(FilingComponentCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static optionalservice(
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/optionalservice";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingCode1(
        params: {
            /**  */
            countyId: string;
            /**  */
            filingCodeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/optionalservice/County/{CountyID}/FilingCode/{FilingCodeID}";
            url = url.replace("{CountyID}", params["countyId"] + "");
            url = url.replace("{FilingCodeID}", params["filingCodeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county2(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/optionalservice/County/{CountyID}";
            url = url.replace("{CountyID}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId1(
        params: {
            /**  */
            filingCodeId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<OptionalServicesCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCodes/optionsalservice/FilingCode/{FilingCodeID}/ePortalID/{ePortalID}";
            url = url.replace("{FilingCodeID}", params["filingCodeId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(OptionalServicesCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static remedy(options: IRequestOptions = {}): Promise<RemedyCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/remedy";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(RemedyCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static remedy1(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<RemedyCode[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCodes/remedy/{divisionID}";
            url = url.replace("{divisionID}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(RemedyCode, response)),
                reject
            );
        });
    }
}

export class TylerCountyService {
    /**
     *
     */
    static tylerCounty(options: IRequestOptions = {}): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCounty";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static state(
        params: {
            /**  */
            state: string;
            /**  */
            all?: boolean;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCounty/state/{state}";
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { all: params["all"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static stateid(
        params: {
            /**  */
            stateId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCounty/stateid/{stateId}";
            url = url.replace("{stateId}", params["stateId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static tylerCounty1(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerCounty/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static portalid(
        params: {
            /**  */
            stateId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerCounty/portalid/{stateId}/{ePortalId}";
            url = url.replace("{stateId}", params["stateId"] + "");
            url = url.replace("{ePortalId}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            portalIdentifier: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<County[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerCounty/update/{portalIdentifier}";
            url = url.replace(
                "{portalIdentifier}",
                params["portalIdentifier"] + ""
            );

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(County, response)),
                reject
            );
        });
    }
}

export class TylerDivisionService {
    /**
     *
     */
    static county(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDivision/county/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static tylerDivision(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDivision/{divisionId}";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static judicialofficers(
        params: {
            /**  */
            divisionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JudicialOfficerListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerDivision/{divisionId}/judicialofficers";
            url = url.replace("{divisionId}", params["divisionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            JudicialOfficerListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static tylerDivision1(
        params: {
            /**  */
            countyId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerDivision/{countyId}/{ePortalId}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{ePortalId}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static byname(
        params: {
            /**  */
            countyId: string;
            /**  */
            name?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDivision/{countyId}/byname";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { name: params["name"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static divisionbyaddress(
        params: {
            /** requestBody */
            body?: DivisionLocationRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDivision/divisionbyaddress";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static divisionbylatlon(
        params: {
            /** requestBody */
            body?: DivisionLocationRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDivision/divisionbylatlon";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Division[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDivision/update/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(Division, response)),
                reject
            );
        });
    }
}

export class TylerDocumentTypeService {
    /**
     *
     */
    static id(
        params: {
            /**  */
            docTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDocumentType/id/{docTypeID}";
            url = url.replace("{docTypeID}", params["docTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static tylerDocumentType(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerDocumentType/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county(
        params: {
            /**  */
            countyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/tyler/TylerDocumentType/county/{countyId}";
            url = url.replace("{countyId}", params["countyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static county1(
        params: {
            /**  */
            countyId: string;
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerDocumentType/county/{countyId}/{caseTypeId}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentType> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerDocumentType/caseType/{caseTypeID}/ePortalID/{ePortalID}";
            url = url.replace("{caseTypeID}", params["caseTypeId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filingCode(
        params: {
            /**  */
            countyId: string;
            /**  */
            filingCode: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IDocumentType[]> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerDocumentType/county/{countyID}/filingCode/{filingCode}";
            url = url.replace("{countyID}", params["countyId"] + "");
            url = url.replace("{filingCode}", params["filingCode"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IDocumentType, response)),
                reject
            );
        });
    }
}

export class TylerFeeService {
    /**
     *
     */
    static tylerFee(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IFee[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerFee/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) => resolve(plainToClass(IFee, response)),
                reject
            );
        });
    }
}

export class TylerPartyTypeService {
    /**
     *
     */
    static tylerPartyType(
        params: {
            /**  */
            caseTypeId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IPartyType[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerPartyType/{caseTypeId}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(IPartyType, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static byname(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            name?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyTypeCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerPartyType/caseType/{caseTypeId}/byname";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { name: params["name"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyTypeCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId(
        params: {
            /**  */
            caseTypeId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyTypeCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerPartyType/caseType/{caseTypeId}/ePortalID/{ePortalID}";
            url = url.replace("{caseTypeId}", params["caseTypeId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyTypeCode, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ePortalId1(
        params: {
            /**  */
            countyId: string;
            /**  */
            ePortalId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyTypeCode> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/TylerPartyType/county/{countyID}/ePortalID/{ePortalID}";
            url = url.replace("{countyID}", params["countyId"] + "");
            url = url.replace("{ePortalID}", params["ePortalId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyTypeCode, response)),
                reject
            );
        });
    }
}

export class Address {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "fullAddress"?: string;

    /**  */
    "streetAddress"?: string;

    /**  */
    "unit"?: string;

    /**  */
    "city"?: string;

    /**  */
    "state"?: string;

    /**  */
    "zip"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    @Expose()
    "latitude"?: number;

    /**  */
    @Expose()
    "longitude"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["fullAddress"] = data["fullAddress"];
        this["streetAddress"] = data["streetAddress"];
        this["unit"] = data["unit"];
        this["city"] = data["city"];
        this["state"] = data["state"];
        this["zip"] = data["zip"];
        this["active"] = data["active"];
        this["latitude"] = data["latitude"];
        this["longitude"] = data["longitude"];
    }

    public static validationModel = {};
}

export class CaseData {
    /**  */
    "ucn"?: string;

    /**  */
    "county"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "division"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    /**  */
    "efmeCaseType"?: string;

    /**  */
    "caseType"?: string;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    /**  */
    @Expose()
    "caseTypeRuleID"?: string;

    /**  */
    "caseSubType"?: string;

    /**  */
    @Expose()
    "caseSubTypeID"?: string;

    /**  */
    "courtCaseNumber"?: string;

    /**  */
    "clientCaseNumber"?: string;

    /**  */
    "caseTitle"?: string;

    /**  */
    @Expose()
    "year"?: number;

    /**  */
    "sequenceNumber"?: string;

    /**  */
    "clientMatterNumber"?: string;

    /**  */
    "isClassAction"?: boolean;

    /**  */
    "hasRelatedCases"?: boolean;

    /**  */
    "demandForJuryTrial"?: boolean;

    /**  */
    @Expose()
    "totalDefendants"?: number;

    /**  */
    @Expose()
    "causeOfActionCount"?: number;

    /**  */
    "isMonetary"?: boolean;

    /**  */
    "isNonMonetary"?: boolean;

    /**  */
    "isInjunctiveRelief"?: boolean;

    /**  */
    "isPunitive"?: boolean;

    /**  */
    "isComplexBusiness"?: boolean;

    /**  */
    @Expose()
    "subpoenaCount"?: number;

    /**  */
    @Expose()
    "smallClaimsAmount"?: number;

    /**  */
    "relatedCaseNumber"?: string;

    /**  */
    "claimAmount"?: string;

    /**  */
    "beginDateOfService"?: string;

    /**  */
    "endDateOfService"?: string;

    /**  */
    "dateOfAccident"?: string;

    /**  */
    "paymentToken"?: string;

    /**  */
    @Expose()
    "summonsCount"?: number;

    /**  */
    "cvv"?: string;

    /**  */
    "judicialOfficerID"?: string;

    /**  */
    @Expose()
    "damagesCodeID"?: string;

    /**  */
    "leadAttorney"?: Party;

    constructor(data: undefined | any = {}) {
        this["ucn"] = data["ucn"];
        this["county"] = data["county"];
        this["countyID"] = data["countyID"];
        this["division"] = data["division"];
        this["divisionID"] = data["divisionID"];
        this["efmeCaseType"] = data["efmeCaseType"];
        this["caseType"] = data["caseType"];
        this["caseTypeID"] = data["caseTypeID"];
        this["caseTypeRuleID"] = data["caseTypeRuleID"];
        this["caseSubType"] = data["caseSubType"];
        this["caseSubTypeID"] = data["caseSubTypeID"];
        this["courtCaseNumber"] = data["courtCaseNumber"];
        this["clientCaseNumber"] = data["clientCaseNumber"];
        this["caseTitle"] = data["caseTitle"];
        this["year"] = data["year"];
        this["sequenceNumber"] = data["sequenceNumber"];
        this["clientMatterNumber"] = data["clientMatterNumber"];
        this["isClassAction"] = data["isClassAction"];
        this["hasRelatedCases"] = data["hasRelatedCases"];
        this["demandForJuryTrial"] = data["demandForJuryTrial"];
        this["totalDefendants"] = data["totalDefendants"];
        this["causeOfActionCount"] = data["causeOfActionCount"];
        this["isMonetary"] = data["isMonetary"];
        this["isNonMonetary"] = data["isNonMonetary"];
        this["isInjunctiveRelief"] = data["isInjunctiveRelief"];
        this["isPunitive"] = data["isPunitive"];
        this["isComplexBusiness"] = data["isComplexBusiness"];
        this["subpoenaCount"] = data["subpoenaCount"];
        this["smallClaimsAmount"] = data["smallClaimsAmount"];
        this["relatedCaseNumber"] = data["relatedCaseNumber"];
        this["claimAmount"] = data["claimAmount"];
        this["beginDateOfService"] = data["beginDateOfService"];
        this["endDateOfService"] = data["endDateOfService"];
        this["dateOfAccident"] = data["dateOfAccident"];
        this["paymentToken"] = data["paymentToken"];
        this["summonsCount"] = data["summonsCount"];
        this["cvv"] = data["cvv"];
        this["judicialOfficerID"] = data["judicialOfficerID"];
        this["damagesCodeID"] = data["damagesCodeID"];
        this["leadAttorney"] = data["leadAttorney"];
    }

    public static validationModel = {};
}

export class CaseSubType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "name"?: string;

    /**  */
    "code"?: string;

    /**  */
    "localNodeID"?: string;

    /**  */
    "useAsDefault"?: boolean;

    /**  */
    "active"?: boolean;

    /**  */
    "initial"?: boolean;

    /**  */
    @Expose()
    "caseTypeID": string;

    /**  */
    @Expose()
    "matchingRuleID"?: string;

    /**  */
    "caseType"?: CaseType;

    /**  */
    "caseTypePortalID"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["ePortalID"] = data["ePortalID"];
        this["name"] = data["name"];
        this["code"] = data["code"];
        this["localNodeID"] = data["localNodeID"];
        this["useAsDefault"] = data["useAsDefault"];
        this["active"] = data["active"];
        this["initial"] = data["initial"];
        this["caseTypeID"] = data["caseTypeID"];
        this["matchingRuleID"] = data["matchingRuleID"];
        this["caseType"] = data["caseType"];
        this["caseTypePortalID"] = data["caseTypePortalID"];
    }

    public static validationModel = {
        ePortalID: { maxLength: 255 },
        name: { maxLength: 255 },
        code: { maxLength: 255 },
        localNodeID: { maxLength: 255 },
        caseTypeID: { required: true },
    };
}

export class CaseType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "caseTypeCode"?: string;

    /**  */
    "localNodeID"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "description"?: string;

    /**  */
    "useAsDefault"?: boolean;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    "initial"?: boolean;

    /**  */
    "caseTypeCategoryName"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    "caseSubTypes"?: CaseSubType[];

    /**  */
    @Expose()
    "divisionID": string;

    /**  */
    "division"?: Division;

    /**  */
    "name"?: string;

    /**  */
    "portalId"?: string;

    /**  */
    "category"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["caseTypeCode"] = data["caseTypeCode"];
        this["localNodeID"] = data["localNodeID"];
        this["ePortalID"] = data["ePortalID"];
        this["description"] = data["description"];
        this["useAsDefault"] = data["useAsDefault"];
        this["fee"] = data["fee"];
        this["initial"] = data["initial"];
        this["caseTypeCategoryName"] = data["caseTypeCategoryName"];
        this["active"] = data["active"];
        this["caseSubTypes"] = data["caseSubTypes"];
        this["divisionID"] = data["divisionID"];
        this["division"] = data["division"];
        this["name"] = data["name"];
        this["portalId"] = data["portalId"];
        this["category"] = data["category"];
    }

    public static validationModel = {
        caseTypeCode: { maxLength: 255 },
        localNodeID: { maxLength: 255 },
        ePortalID: { maxLength: 255 },
        caseTypeCategoryName: { maxLength: 511 },
        divisionID: { required: true },
    };
}

export class CaseTypeCoverSheet {
    /**  */
    "caseType"?: string;

    /**  */
    "formFieldId"?: string;

    /**  */
    @Expose()
    "minAmount"?: number;

    /**  */
    @Expose()
    "maxAmount"?: number;

    /**  */
    "newCaseType"?: string;

    /**  */
    "templateName"?: string;

    constructor(data: undefined | any = {}) {
        this["caseType"] = data["caseType"];
        this["formFieldId"] = data["formFieldId"];
        this["minAmount"] = data["minAmount"];
        this["maxAmount"] = data["maxAmount"];
        this["newCaseType"] = data["newCaseType"];
        this["templateName"] = data["templateName"];
    }

    public static validationModel = {};
}

export class CaseTypeCoverSheetDetailedResponse {
    /**  */
    "data"?: CaseTypeCoverSheet;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CaseTypeListDetailedResponse {
    /**  */
    "data"?: CaseType[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CaseTypeStaging {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "caseTypeCode"?: string;

    /**  */
    "localNodeID"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "description"?: string;

    /**  */
    "useAsDefault"?: boolean;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    "initial"?: boolean;

    /**  */
    "caseTypeCategoryName"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    @Expose()
    "divisionID": string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["caseTypeCode"] = data["caseTypeCode"];
        this["localNodeID"] = data["localNodeID"];
        this["ePortalID"] = data["ePortalID"];
        this["description"] = data["description"];
        this["useAsDefault"] = data["useAsDefault"];
        this["fee"] = data["fee"];
        this["initial"] = data["initial"];
        this["caseTypeCategoryName"] = data["caseTypeCategoryName"];
        this["active"] = data["active"];
        this["divisionID"] = data["divisionID"];
    }

    public static validationModel = {
        caseTypeCode: { maxLength: 255 },
        localNodeID: { maxLength: 255 },
        ePortalID: { maxLength: 255 },
        caseTypeCategoryName: { maxLength: 511 },
        divisionID: { required: true },
    };
}

export class CaseTypeStagingListDetailedResponse {
    /**  */
    "data"?: CaseTypeStaging[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class ContactInformation {
    /**  */
    @Expose()
    "submissionAddressID"?: number;

    /**  */
    "fullAddress"?: string;

    /**  */
    "state"?: string;

    /**  */
    "streetAddress1"?: string;

    /**  */
    "streetAddress2"?: string;

    /**  */
    "zip"?: string;

    /**  */
    "city"?: string;

    /**  */
    "phoneNumber"?: string;

    /**  */
    "emailAddress"?: string;

    constructor(data: undefined | any = {}) {
        this["submissionAddressID"] = data["submissionAddressID"];
        this["fullAddress"] = data["fullAddress"];
        this["state"] = data["state"];
        this["streetAddress1"] = data["streetAddress1"];
        this["streetAddress2"] = data["streetAddress2"];
        this["zip"] = data["zip"];
        this["city"] = data["city"];
        this["phoneNumber"] = data["phoneNumber"];
        this["emailAddress"] = data["emailAddress"];
    }

    public static validationModel = {};
}

export class County {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "portalIdentifier"?: string;

    /**  */
    "initialFiling"?: boolean;

    /**  */
    "subsequentFiling"?: boolean;

    /**  */
    "allowNonIndexed"?: boolean;

    /**  */
    "allowedCardTypes"?: string;

    /**  */
    "protectedCaseTypes"?: string;

    /**  */
    "generateCoverSheet"?: boolean;

    /**  */
    "circuit"?: string;

    /**  */
    @Expose()
    "stateID": string;

    /**  */
    "state"?: State;

    /**  */
    @Expose()
    "parentID"?: string;

    /**  */
    "parent"?: County;

    /**  */
    "parentPortalID"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["portalIdentifier"] = data["portalIdentifier"];
        this["initialFiling"] = data["initialFiling"];
        this["subsequentFiling"] = data["subsequentFiling"];
        this["allowNonIndexed"] = data["allowNonIndexed"];
        this["allowedCardTypes"] = data["allowedCardTypes"];
        this["protectedCaseTypes"] = data["protectedCaseTypes"];
        this["generateCoverSheet"] = data["generateCoverSheet"];
        this["circuit"] = data["circuit"];
        this["stateID"] = data["stateID"];
        this["state"] = data["state"];
        this["parentID"] = data["parentID"];
        this["parent"] = data["parent"];
        this["parentPortalID"] = data["parentPortalID"];
    }

    public static validationModel = {
        name: { maxLength: 127 },
        ePortalID: { maxLength: 31 },
        circuit: { maxLength: 255 },
        stateID: { required: true },
    };
}

export class CourtType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    /**  */
    "code"?: string;

    /**  */
    "name"?: string;

    /**  */
    "division"?: Division;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["divisionID"] = data["divisionID"];
        this["code"] = data["code"];
        this["name"] = data["name"];
        this["division"] = data["division"];
    }

    public static validationModel = {};
}

export class CoversheetCaseSubType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "documentMappingValue"?: string;

    /**  */
    "ePortalValue"?: string;

    /**  */
    @Expose()
    "coversheetCaseTypeID"?: string;

    /**  */
    "coversheetCaseType"?: CoversheetCaseType;

    /**  */
    "display"?: boolean;

    /**  */
    @Expose()
    "minimumAmount"?: number;

    /**  */
    @Expose()
    "maxiumAmount"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["documentMappingValue"] = data["documentMappingValue"];
        this["ePortalValue"] = data["ePortalValue"];
        this["coversheetCaseTypeID"] = data["coversheetCaseTypeID"];
        this["coversheetCaseType"] = data["coversheetCaseType"];
        this["display"] = data["display"];
        this["minimumAmount"] = data["minimumAmount"];
        this["maxiumAmount"] = data["maxiumAmount"];
    }

    public static validationModel = {};
}

export class CoversheetCaseType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "documentMappingValue"?: string;

    /**  */
    "ePortalValue"?: string;

    /**  */
    @Expose()
    "coversheetCourtTypeID"?: string;

    /**  */
    "display"?: boolean;

    /**  */
    @Expose()
    "minimumAmount"?: number;

    /**  */
    @Expose()
    "maxiumAmount"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["documentMappingValue"] = data["documentMappingValue"];
        this["ePortalValue"] = data["ePortalValue"];
        this["coversheetCourtTypeID"] = data["coversheetCourtTypeID"];
        this["display"] = data["display"];
        this["minimumAmount"] = data["minimumAmount"];
        this["maxiumAmount"] = data["maxiumAmount"];
    }

    public static validationModel = {};
}

export class CoversheetCaseTypeDetailedResponse {
    /**  */
    "data"?: CoversheetCaseType;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CoversheetCourtType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    @Expose()
    "minAmount"?: number;

    /**  */
    @Expose()
    "maxAmount"?: number;

    /**  */
    "templateFilename"?: string;

    /**  */
    @Expose()
    "stateID"?: string;

    /**  */
    "state"?: State;

    /**  */
    "display"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["minAmount"] = data["minAmount"];
        this["maxAmount"] = data["maxAmount"];
        this["templateFilename"] = data["templateFilename"];
        this["stateID"] = data["stateID"];
        this["state"] = data["state"];
        this["display"] = data["display"];
    }

    public static validationModel = {};
}

export class CrossReferenceCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "name"?: string;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    /**  */
    "isRequired"?: boolean;

    /**  */
    "isDefault"?: boolean;

    /**  */
    "validationRegex"?: string;

    /**  */
    "customValidationMessage"?: string;

    /**  */
    "caseType"?: CaseType;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["ePortalID"] = data["ePortalID"];
        this["name"] = data["name"];
        this["caseTypeID"] = data["caseTypeID"];
        this["isRequired"] = data["isRequired"];
        this["isDefault"] = data["isDefault"];
        this["validationRegex"] = data["validationRegex"];
        this["customValidationMessage"] = data["customValidationMessage"];
        this["caseType"] = data["caseType"];
    }

    public static validationModel = {
        ePortalID: { maxLength: 127 },
        name: { maxLength: 1023 },
        validationRegex: { maxLength: 127 },
        customValidationMessage: { maxLength: 1023 },
    };
}

export class DamageCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    /**  */
    "division"?: Division;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["divisionID"] = data["divisionID"];
        this["division"] = data["division"];
    }

    public static validationModel = {
        name: { maxLength: 255 },
        ePortalID: { maxLength: 63 },
    };
}

export class DataTag {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "text"?: string;

    /**  */
    @Expose()
    "amount"?: number;

    /**  */
    "tag"?: string;

    /**  */
    "isAmountDependent"?: boolean;

    /**  */
    "isActive"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["text"] = data["text"];
        this["amount"] = data["amount"];
        this["tag"] = data["tag"];
        this["isAmountDependent"] = data["isAmountDependent"];
        this["isActive"] = data["isActive"];
    }

    public static validationModel = {};
}

export class DataTagMap {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "dataTagID"?: string;

    /**  */
    "dataTag"?: DataTag;

    /**  */
    "mergefield"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["dataTagID"] = data["dataTagID"];
        this["dataTag"] = data["dataTag"];
        this["mergefield"] = data["mergefield"];
    }

    public static validationModel = {};
}

export class Division {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "code"?: string;

    /**  */
    "remedyInitial"?: boolean;

    /**  */
    "claimAmountInitial"?: boolean;

    /**  */
    @Expose()
    "countyID": string;

    /**  */
    "county"?: County;

    /**  */
    "courtTypes"?: CourtType[];

    /**  */
    "claimAmountSupported"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["code"] = data["code"];
        this["remedyInitial"] = data["remedyInitial"];
        this["claimAmountInitial"] = data["claimAmountInitial"];
        this["countyID"] = data["countyID"];
        this["county"] = data["county"];
        this["courtTypes"] = data["courtTypes"];
        this["claimAmountSupported"] = data["claimAmountSupported"];
    }

    public static validationModel = {
        name: { maxLength: 128 },
        ePortalID: { maxLength: 31 },
        countyID: { required: true },
    };
}

export class DivisionLocationRequest {
    /**  */
    @Expose()
    "countyId"?: string;

    /**  */
    "address"?: Address;

    /**  */
    @Expose()
    "latitude"?: number;

    /**  */
    @Expose()
    "longitude"?: number;

    /**  */
    @Expose()
    "claimAmount"?: number;

    constructor(data: undefined | any = {}) {
        this["countyId"] = data["countyId"];
        this["address"] = data["address"];
        this["latitude"] = data["latitude"];
        this["longitude"] = data["longitude"];
        this["claimAmount"] = data["claimAmount"];
    }

    public static validationModel = {};
}

export class DocumentTag {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "text"?: string;

    /**  */
    "display"?: string;

    /**  */
    "type"?: string;

    /**  */
    @Expose()
    "amount"?: number;

    /**  */
    "isAmountDependent"?: boolean;

    /**  */
    "isActive"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["text"] = data["text"];
        this["display"] = data["display"];
        this["type"] = data["type"];
        this["amount"] = data["amount"];
        this["isAmountDependent"] = data["isAmountDependent"];
        this["isActive"] = data["isActive"];
    }

    public static validationModel = {};
}

export class DocumentType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "documentCategory"?: string;

    /**  */
    @Expose()
    "stateID"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    "subType"?: boolean;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    /**  */
    @Expose()
    "caseSubTypeID"?: string;

    /**  */
    @Expose()
    "feeAmount"?: number;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    "initialFiling"?: boolean;

    /**  */
    "subsequentFiling"?: boolean;

    /**  */
    "code"?: string;

    /**  */
    "filingCode"?: string;

    /**  */
    "localNodeID"?: string;

    /**  */
    "county"?: County;

    /**  */
    "division"?: Division;

    /**  */
    "state"?: State;

    /**  */
    "caseType"?: CaseType;

    /**  */
    "caseSubType"?: CaseSubType;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["documentCategory"] = data["documentCategory"];
        this["stateID"] = data["stateID"];
        this["active"] = data["active"];
        this["subType"] = data["subType"];
        this["countyID"] = data["countyID"];
        this["divisionID"] = data["divisionID"];
        this["caseTypeID"] = data["caseTypeID"];
        this["caseSubTypeID"] = data["caseSubTypeID"];
        this["feeAmount"] = data["feeAmount"];
        this["fee"] = data["fee"];
        this["initialFiling"] = data["initialFiling"];
        this["subsequentFiling"] = data["subsequentFiling"];
        this["code"] = data["code"];
        this["filingCode"] = data["filingCode"];
        this["localNodeID"] = data["localNodeID"];
        this["county"] = data["county"];
        this["division"] = data["division"];
        this["state"] = data["state"];
        this["caseType"] = data["caseType"];
        this["caseSubType"] = data["caseSubType"];
    }

    public static validationModel = {
        name: { maxLength: 255 },
        ePortalID: { maxLength: 63 },
        documentCategory: { maxLength: 63 },
        localNodeID: { maxLength: 15 },
    };
}

export class FilerCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "description"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "defaultValue"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "county"?: County;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["description"] = data["description"];
        this["ePortalID"] = data["ePortalID"];
        this["defaultValue"] = data["defaultValue"];
        this["countyID"] = data["countyID"];
        this["county"] = data["county"];
    }

    public static validationModel = {
        description: { maxLength: 255 },
        ePortalID: { maxLength: 63 },
        defaultValue: { maxLength: 63 },
    };
}

export class FilingCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "name"?: string;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    "caseCategory"?: string;

    /**  */
    "caseType"?: string;

    /**  */
    "filingType"?: string;

    /**  */
    "efspCode"?: string;

    /**  */
    "forCourtUseOnly"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["countyID"] = data["countyID"];
        this["ePortalID"] = data["ePortalID"];
        this["name"] = data["name"];
        this["fee"] = data["fee"];
        this["caseCategory"] = data["caseCategory"];
        this["caseType"] = data["caseType"];
        this["filingType"] = data["filingType"];
        this["efspCode"] = data["efspCode"];
        this["forCourtUseOnly"] = data["forCourtUseOnly"];
    }

    public static validationModel = {
        ePortalID: { maxLength: 31 },
        name: { maxLength: 127 },
        caseCategory: { maxLength: 50 },
        caseType: { maxLength: 50 },
        filingType: { maxLength: 50 },
        efspCode: { maxLength: 50 },
    };
}

export class FilingComponentCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    @Expose()
    "filingCodeID"?: string;

    /**  */
    "allowMultiple"?: boolean;

    /**  */
    "isRequired"?: boolean;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "filingCode"?: FilingCode;

    /**  */
    "county"?: County;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["filingCodeID"] = data["filingCodeID"];
        this["allowMultiple"] = data["allowMultiple"];
        this["isRequired"] = data["isRequired"];
        this["countyID"] = data["countyID"];
        this["filingCode"] = data["filingCode"];
        this["county"] = data["county"];
    }

    public static validationModel = {
        name: { maxLength: 255 },
        ePortalID: { maxLength: 63 },
    };
}

export class FilingHelpNoteRequest {
    /**  */
    @Expose()
    "stateID"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    /**  */
    @Expose()
    "documentTypeID"?: string;

    constructor(data: undefined | any = {}) {
        this["stateID"] = data["stateID"];
        this["countyID"] = data["countyID"];
        this["caseTypeID"] = data["caseTypeID"];
        this["documentTypeID"] = data["documentTypeID"];
    }

    public static validationModel = {};
}

export class GroupedNotes {
    /**  */
    "group0"?: IHelpNote[];

    /**  */
    "group1"?: IHelpNote[];

    /**  */
    "group2"?: IHelpNote[];

    /**  */
    "group3"?: IHelpNote[];

    constructor(data: undefined | any = {}) {
        this["group0"] = data["group0"];
        this["group1"] = data["group1"];
        this["group2"] = data["group2"];
        this["group3"] = data["group3"];
    }

    public static validationModel = {};
}

export class GroupedNotesDetailedResponse {
    /**  */
    "data"?: GroupedNotes;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class IDocumentType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "documentCategory"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    "subType"?: boolean;

    /**  */
    @Expose()
    "feeAmount"?: number;

    /**  */
    "localNodeID"?: string;

    /**  */
    "initialFiling"?: boolean;

    /**  */
    "subsequentFiling"?: boolean;

    /**  */
    "code"?: string;

    /**  */
    "filingCode"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["documentCategory"] = data["documentCategory"];
        this["active"] = data["active"];
        this["subType"] = data["subType"];
        this["feeAmount"] = data["feeAmount"];
        this["localNodeID"] = data["localNodeID"];
        this["initialFiling"] = data["initialFiling"];
        this["subsequentFiling"] = data["subsequentFiling"];
        this["code"] = data["code"];
        this["filingCode"] = data["filingCode"];
        this["countyID"] = data["countyID"];
    }

    public static validationModel = {};
}

export class IFee {
    /**  */
    "description"?: string;

    /**  */
    @Expose()
    "amount"?: number;

    /**  */
    @Expose()
    "quantity"?: number;

    /**  */
    "ePortalID"?: string;

    constructor(data: undefined | any = {}) {
        this["description"] = data["description"];
        this["amount"] = data["amount"];
        this["quantity"] = data["quantity"];
        this["ePortalID"] = data["ePortalID"];
    }

    public static validationModel = {};
}

export class IHelpNote {
    /**  */
    @Expose()
    "helpLevel"?: number;

    /**  */
    "helpNote"?: string;

    /**  */
    @Expose()
    "id"?: string;

    constructor(data: undefined | any = {}) {
        this["helpLevel"] = data["helpLevel"];
        this["helpNote"] = data["helpNote"];
        this["id"] = data["id"];
    }

    public static validationModel = {};
}

export class IPartyType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "description"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "isForNewCases"?: boolean;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    "isRequired"?: boolean;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["description"] = data["description"];
        this["ePortalID"] = data["ePortalID"];
        this["isForNewCases"] = data["isForNewCases"];
        this["fee"] = data["fee"];
        this["isRequired"] = data["isRequired"];
        this["countyID"] = data["countyID"];
        this["caseTypeID"] = data["caseTypeID"];
    }

    public static validationModel = {};
}

export class JPLocationData {
    /**  */
    "addresS1"?: string;

    /**  */
    "addresS2"?: string;

    /**  */
    "county"?: string;

    /**  */
    "citY1"?: string;

    /**  */
    "citY2"?: string;

    /**  */
    "fid"?: string;

    /**  */
    "firstnamE1"?: string;

    /**  */
    "firstnamE2"?: string;

    /**  */
    "lastnamE1"?: string;

    /**  */
    "lastnamE2"?: string;

    /**  */
    "officE1"?: string;

    /**  */
    "officE2"?: string;

    /**  */
    "precinct"?: string;

    /**  */
    "seaT1"?: string;

    /**  */
    "seaT2"?: string;

    /**  */
    "shape__Area"?: string;

    /**  */
    "shape__Length"?: string;

    /**  */
    "shape_Area"?: string;

    /**  */
    "shape_Leng"?: string;

    /**  */
    "statE1"?: string;

    /**  */
    "statE2"?: string;

    /**  */
    "teL1"?: string;

    /**  */
    "teL2"?: string;

    /**  */
    "titlE1"?: string;

    /**  */
    "titlE2"?: string;

    /**  */
    "ziP1"?: string;

    /**  */
    "ziP2"?: string;

    constructor(data: undefined | any = {}) {
        this["addresS1"] = data["addresS1"];
        this["addresS2"] = data["addresS2"];
        this["county"] = data["county"];
        this["citY1"] = data["citY1"];
        this["citY2"] = data["citY2"];
        this["fid"] = data["fid"];
        this["firstnamE1"] = data["firstnamE1"];
        this["firstnamE2"] = data["firstnamE2"];
        this["lastnamE1"] = data["lastnamE1"];
        this["lastnamE2"] = data["lastnamE2"];
        this["officE1"] = data["officE1"];
        this["officE2"] = data["officE2"];
        this["precinct"] = data["precinct"];
        this["seaT1"] = data["seaT1"];
        this["seaT2"] = data["seaT2"];
        this["shape__Area"] = data["shape__Area"];
        this["shape__Length"] = data["shape__Length"];
        this["shape_Area"] = data["shape_Area"];
        this["shape_Leng"] = data["shape_Leng"];
        this["statE1"] = data["statE1"];
        this["statE2"] = data["statE2"];
        this["teL1"] = data["teL1"];
        this["teL2"] = data["teL2"];
        this["titlE1"] = data["titlE1"];
        this["titlE2"] = data["titlE2"];
        this["ziP1"] = data["ziP1"];
        this["ziP2"] = data["ziP2"];
    }

    public static validationModel = {};
}

export class JPLocationDataDetailedResponse {
    /**  */
    "data"?: JPLocationData;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class JudicialOfficer {
    /**  */
    "name"?: string;

    /**  */
    "division"?: string;

    /**  */
    "ePortalID"?: string;

    constructor(data: undefined | any = {}) {
        this["name"] = data["name"];
        this["division"] = data["division"];
        this["ePortalID"] = data["ePortalID"];
    }

    public static validationModel = {};
}

export class JudicialOfficerDetailedResponse {
    /**  */
    "data"?: JudicialOfficer;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class JudicialOfficerListDetailedResponse {
    /**  */
    "data"?: JudicialOfficer[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class MappedCoversheetRequest {
    /**  */
    "caseData"?: CaseData;

    /**  */
    @Expose()
    "claimAmount"?: number;

    constructor(data: undefined | any = {}) {
        this["caseData"] = data["caseData"];
        this["claimAmount"] = data["claimAmount"];
    }

    public static validationModel = {};
}

export class OptionalServicesCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "filingCode"?: string;

    /**  */
    "feeDescription"?: string;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    "multipler"?: boolean;

    /**  */
    @Expose()
    "displayOrder"?: number;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "county"?: County;

    /**  */
    @Expose()
    "quantity"?: number;

    /**  */
    "code"?: string;

    /**  */
    @Expose()
    "multiplier"?: number;

    /**  */
    "allowMultiplier"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["filingCode"] = data["filingCode"];
        this["feeDescription"] = data["feeDescription"];
        this["fee"] = data["fee"];
        this["multipler"] = data["multipler"];
        this["displayOrder"] = data["displayOrder"];
        this["countyID"] = data["countyID"];
        this["county"] = data["county"];
        this["quantity"] = data["quantity"];
        this["code"] = data["code"];
        this["multiplier"] = data["multiplier"];
        this["allowMultiplier"] = data["allowMultiplier"];
    }

    public static validationModel = {
        name: { maxLength: 255 },
        ePortalID: { maxLength: 63 },
        feeDescription: { maxLength: 255 },
    };
}

export class Party {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    @Expose()
    "partyID"?: number;

    /**  */
    "barNumber"?: string;

    /**  */
    "firstName"?: string;

    /**  */
    "middleName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "suffix"?: string;

    /**  */
    "organization"?: string;

    /**  */
    "guid"?: string;

    /**  */
    "paymentToken"?: string;

    /**  */
    "representedPartyGUID"?: string;

    /**  */
    "contactInfo"?: ContactInformation;

    /**  */
    "partyType"?: string;

    /**  */
    "partyTypeCode"?: string;

    /**  */
    "emailAddress"?: string;

    /**  */
    "interestedParty"?: Party;

    /**  */
    "routingNumber"?: string;

    /**  */
    "accountNumber"?: string;

    /**  */
    "accountName"?: string;

    /**  */
    @Expose()
    "efmeFilingFee"?: number;

    /**  */
    @Expose()
    "efmeFilingTaxAmount"?: number;

    /**  */
    "portalID"?: string;

    /**  */
    "attorneyID"?: string;

    /**  */
    "name"?: string;

    /**  */
    "fullName"?: string;

    /**  */
    "address"?: Address;

    /**  */
    "phoneNumber"?: string;

    /**  */
    "username"?: string;

    /**  */
    "isLeadAttorney"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["partyID"] = data["partyID"];
        this["barNumber"] = data["barNumber"];
        this["firstName"] = data["firstName"];
        this["middleName"] = data["middleName"];
        this["lastName"] = data["lastName"];
        this["suffix"] = data["suffix"];
        this["organization"] = data["organization"];
        this["guid"] = data["guid"];
        this["paymentToken"] = data["paymentToken"];
        this["representedPartyGUID"] = data["representedPartyGUID"];
        this["contactInfo"] = data["contactInfo"];
        this["partyType"] = data["partyType"];
        this["partyTypeCode"] = data["partyTypeCode"];
        this["emailAddress"] = data["emailAddress"];
        this["interestedParty"] = data["interestedParty"];
        this["routingNumber"] = data["routingNumber"];
        this["accountNumber"] = data["accountNumber"];
        this["accountName"] = data["accountName"];
        this["efmeFilingFee"] = data["efmeFilingFee"];
        this["efmeFilingTaxAmount"] = data["efmeFilingTaxAmount"];
        this["portalID"] = data["portalID"];
        this["attorneyID"] = data["attorneyID"];
        this["name"] = data["name"];
        this["fullName"] = data["fullName"];
        this["address"] = data["address"];
        this["phoneNumber"] = data["phoneNumber"];
        this["username"] = data["username"];
        this["isLeadAttorney"] = data["isLeadAttorney"];
    }

    public static validationModel = {};
}

export class PartyTypeCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "description"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    "isForNewCases"?: boolean;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "isRequired"?: boolean;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    /**  */
    "county"?: County;

    /**  */
    "caseType"?: CaseType;

    /**  */
    "name"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["description"] = data["description"];
        this["ePortalID"] = data["ePortalID"];
        this["isForNewCases"] = data["isForNewCases"];
        this["fee"] = data["fee"];
        this["countyID"] = data["countyID"];
        this["isRequired"] = data["isRequired"];
        this["caseTypeID"] = data["caseTypeID"];
        this["county"] = data["county"];
        this["caseType"] = data["caseType"];
        this["name"] = data["name"];
    }

    public static validationModel = {
        description: { maxLength: 255 },
        ePortalID: { maxLength: 63 },
    };
}

export class RemedyCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    /**  */
    "division"?: Division;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["ePortalID"] = data["ePortalID"];
        this["divisionID"] = data["divisionID"];
        this["division"] = data["division"];
    }

    public static validationModel = {
        name: { maxLength: 63 },
    };
}

export class State {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "abbreviation"?: string;

    /**  */
    "saveDocumentTypes"?: boolean;

    /**  */
    "portal"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["abbreviation"] = data["abbreviation"];
        this["saveDocumentTypes"] = data["saveDocumentTypes"];
        this["portal"] = data["portal"];
    }

    public static validationModel = {};
}

export type AttorneyTypeKeys = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 1000;
